export async function Audience(token: string | null, qtdMinutos: string | null) {
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/audiencia?nLoading=&ultimoNLoading=&qtdeMinutos=' + qtdMinutos,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const request = await axios.request(options);
    return request;
}

export async function AudienceMedia(token: string | null) {
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/media?nLoading=&ultimoNLoading=',
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const request = await axios.request(options);
    return request;
}

export async function AudiencePrint(token: string | null, data: string | null, horaIni: string | null, horaFin: string | null) {
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/audienciaPrint?data=' + data + '&horaini=' + horaIni + '&horafim=' + horaFin,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const request = await axios.request(options);
    return request;
}

export async function UpdateAudienceMediaComp(
    token: string | null,
    indiceaverage: string | null,
    dataaverage: string | null,
    horainiaverage: string | null,
    horafimaverage: string | null,
    autoupdate: string | null,
    mcaction: string | null
) {
    const autoUpdateValue = autoupdate ?? 'true';

    const params = new URLSearchParams();

    if (mcaction === null) {
        params.append('autoUpdate', autoUpdateValue);
    } else {
        params.append('indiceAverage', indiceaverage ?? '');
        params.append('dataAverage', dataaverage ?? '');
        params.append('horaIniAverage', horainiaverage ?? '');
        params.append('horaFimAverage', horafimaverage ?? '');
        params.append('autoUpdate', autoUpdateValue);
        params.append('action', mcaction);
    }

    const axios = require('axios');
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_HOST + 'api/UserTabAverage',
        headers: {
            Authorization: "Bearer " + token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const request = await axios.post(options.url, params.toString(), { headers: options.headers });
    return request;
}


export async function AudienceMediaComp(token: string | null, dataIni: string | null, indiceAverage: string | null) {

    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/UserTabAverage?dataIni=' + dataIni + '&indiceAverage=' + indiceAverage,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const request = await axios.request(options);
    return request;

}


export async function AudienceChart(token: string | null, qtdMinutos: string | null) {
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/chart?nLoading=&ultimoNLoading=&qtdeMinutos=' + qtdMinutos,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const request = await axios.request(options);
    return request;
}